export default __webpack_public_path__ + "static/media/32.b54ac3d1.png";